(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-nav"] && !Shopify.designMode) return;
  try {
    
  class MobileBottomNav extends HTMLElement {
    constructor() {
      super();

      this.cartCountEl = this.querySelector('[data-cart-count]');

      // ─── Scroll hide/show ───
      this.lastScrollY = window.scrollY;
      this.scrollThreshold = 10; // minimum px to trigger hide/show
      this.ticking = false;
      window.addEventListener('scroll', this.onScroll.bind(this), { passive: true });

      // Bind button actions (search & cart only — home & catalog are <a> links)
      this.querySelectorAll('[data-action]').forEach((el) => {
        el.addEventListener('click', (e) => {
          this.handleAction(el.getAttribute('data-action'), e);
        });
      });

      // Cart count sync
      document.addEventListener('theme:cart:update', this.updateCartCount.bind(this));
      document.addEventListener('cart:updated', this.updateCartCount.bind(this));
      this.syncCartCountFromSession();
      this.observeCartBubble();
    }

    /* ═══ SCROLL HIDE/SHOW ═══ */
    onScroll() {
      if (this.ticking) return;
      this.ticking = true;

      requestAnimationFrame(() => {
        const currentY = window.scrollY;
        const diff = currentY - this.lastScrollY;

        // Near top of page — always show
        if (currentY < 100) {
          this.classList.remove('mobile-bottom-nav--hidden');
        }
        // Scrolling down past threshold — hide
        else if (diff > this.scrollThreshold) {
          this.classList.add('mobile-bottom-nav--hidden');
        }
        // Scrolling up past threshold — show
        else if (diff < -this.scrollThreshold) {
          this.classList.remove('mobile-bottom-nav--hidden');
        }

        this.lastScrollY = currentY;
        this.ticking = false;
      });
    }

    handleAction(action) {
      switch (action) {
        case 'open-search':
          this.openSearch();
          break;
        case 'open-cart':
          this.openCart();
          break;
      }
    }

    /* ═══ SEARCH ═══ */
    openSearch() {
      const searchModal = document.querySelector('#search-modal');
      if (searchModal) {
        if (typeof searchModal.showDialog === 'function') {
          searchModal.showDialog();
        } else {
          const dialog = searchModal.querySelector('dialog');
          if (dialog && !dialog.open) dialog.showModal();
        }
      }
    }

    /* ═══ CART ═══ */
    openCart() {
      const cartDrawer = document.querySelector('cart-drawer-component');
      if (cartDrawer) {
        if (typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        } else if (typeof cartDrawer.showDialog === 'function') {
          cartDrawer.showDialog();
        }
        return;
      }
      window.location.href = '/cart';
    }

    /* ═══ CART COUNT SYNC ═══ */
    updateCartCount(event) {
      const count = event?.detail?.data?.itemCount
        ?? event?.detail?.itemCount
        ?? event?.detail?.count
        ?? null;
      if (count !== null) this.setCartCount(count);
    }

    setCartCount(count) {
      if (!this.cartCountEl) return;
      const prevCount = parseInt(this.cartCountEl.textContent || '0', 10);
      this.cartCountEl.textContent = count;

      if (count === 0) {
        this.cartCountEl.classList.add('mobile-bottom-nav__cart-count--hidden');
      } else {
        this.cartCountEl.classList.remove('mobile-bottom-nav__cart-count--hidden');
        if (count !== prevCount) {
          this.cartCountEl.classList.remove('mobile-bottom-nav__cart-count--animate');
          void this.cartCountEl.offsetWidth;
          this.cartCountEl.classList.add('mobile-bottom-nav__cart-count--animate');
        }
      }
    }

    syncCartCountFromSession() {
      try {
        const stored = sessionStorage.getItem('cart-count');
        if (stored) {
          const { value } = JSON.parse(stored);
          const count = parseInt(value, 10);
          if (!isNaN(count)) this.setCartCount(count);
        }
      } catch (_) {}
    }

    observeCartBubble() {
      const headerBubbleCount = document.querySelector('cart-icon [ref="cartBubbleCount"]');
      if (!headerBubbleCount) return;

      const observer = new MutationObserver(() => {
        const text = headerBubbleCount.textContent?.trim();
        const count = text === '' ? 0 : parseInt(text, 10);
        if (!isNaN(count)) this.setCartCount(count);
      });

      observer.observe(headerBubbleCount, {
        childList: true,
        characterData: true,
        subtree: true,
      });
    }
  }

  if (!customElements.get('mobile-bottom-nav')) {
    customElements.define('mobile-bottom-nav', MobileBottomNav);
  }

  } catch(e) { console.error(e); }
})();
})();
